export default __webpack_public_path__ + "static/media/orderform.a04bbf21.svg";